module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('HeaderCompontent'), _vm._v(" "), _c('keep-alive', [_c('router-view')], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-a7ec1dbe!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 271
// module chunks = 3